import './Buttons.scss';

import React from 'react';
import { useTenant } from '../../context/TenantContext';
import { ReactComponent as RefreshIcon } from '../../img/refresh.svg';
import LoadingButton from '../loading/LoadingButton';
import RightArrowIcon from '../rightarrow/RightArrow';

const DEFAULT_WIDTH = 15;
const DEFAULT_HEIGHT = 15;

export const BackButton = ({ onClick, text = 'Atrás' }) => {
  return (
    <button className="back-btn" onClick={onClick}>
      <span className="btn-text">{text}</span>
    </button>
  );
};

export const FinishButton = ({ onClick }) => {
  return (
    <button className="finalize-button" onClick={onClick}>
      Finalizar
    </button>
  );
};

export const ContinueButton = ({
  width,
  height,
  type = 'button',
  onClick,
  text = 'CONTINUAR',
  isLoading,
  disabled = false,
  showIcon = true,
}) => {
  const { isMeliTenant } = useTenant();
  const handleClick = (event) => {
    if (type !== 'submit' && !isLoading && onClick) {
      onClick(event);
    }
  };

  return (
    <button
      className={`continue-btn${isMeliTenant ? ' continue-btn-meli' : ''}${isLoading ? ' continue-btn-loading' : ''}`}
      type={type}
      disabled={isLoading || disabled}
      onClick={handleClick}
    >
      <span className="btn-text">{text}</span>
      {showIcon && (
        <>
          {isLoading ? (
            <LoadingButton />
          ) : (
            <RightArrowIcon
              width={width ? width : DEFAULT_WIDTH}
              height={height ? height : DEFAULT_HEIGHT}
              color={isMeliTenant ? '#fff' : '#1D364C'}
            />
          )}
        </>
      )}
    </button>
  );
};

export const RecalcularButton = ({ width, height, onClick, isLoading }) => {
  return (
    <button
      className={isLoading ? 'recalcular-btn recalcular-btn-loading' : 'recalcular-btn'}
      onClick={onClick}
      disabled={isLoading}
    >
      <span className="btn-text">RECALCULAR </span>
      {isLoading ? (
        <LoadingButton />
      ) : (
        <RefreshIcon
          width={width ? width : DEFAULT_WIDTH}
          height={height ? height : DEFAULT_HEIGHT}
        />
      )}
    </button>
  );
};

const Buttons = { BackButton, RecalcularButton, ContinueButton };

export default Buttons;
